<div class="example-container mat-elevation-z8 overflow"  *ngIf="DataSource">
  <mat-table    [dataSource]="DataSource" matSort >

    <mat-header-row *matHeaderRowDef="DisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: DisplayedColumns"></mat-row>

    <ng-container matColumnDef="item">
        <mat-header-cell *matHeaderCellDef>item</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.item }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="descripcion">
      <mat-header-cell *matHeaderCellDef>descripcion</mat-header-cell>
      <mat-cell *matCellDef="let element">
      <mat-form-field >
        <div class="action-button-container">
          <input type="text" matInput [(ngModel)]="element.descripcion" [disabled]="element.edit" />
        </div>
      </mat-form-field>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="cantidad">
    <mat-header-cell *matHeaderCellDef>cantidad</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <mat-form-field >
        <div class="action-button-container">
          <input type="number" matInput [(ngModel)]="element.cantidad" [disabled]="element.edit" />
        </div>
      </mat-form-field>
    </mat-cell>
</ng-container>

    <ng-container matColumnDef="precioUnidad">
      <mat-header-cell *matHeaderCellDef>precioUnidad</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-form-field >
          <div class="action-button-container">
            <input type="text" matInput [(ngModel)]="element.precioUnidad" [disabled]="element.edit" />
          </div>
        </mat-form-field>
      </mat-cell>
  </ng-container>

  <ng-container matColumnDef="inafecto">
    <mat-header-cell *matHeaderCellDef>inafecto</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <mat-form-field >
        <div class="action-button-container">
          <input type="text" matInput [(ngModel)]="element.inafecto" [disabled]="element.edit" />
        </div>
      </mat-form-field>
    </mat-cell>
</ng-container>

<ng-container matColumnDef="igv">
  <mat-header-cell *matHeaderCellDef>igv</mat-header-cell>
  <mat-cell *matCellDef="let element">
    <mat-form-field >
      <div class="action-button-container">
        <input type="number" matInput [(ngModel)]="element.igv" [disabled]="element.edit" />
      </div>
    </mat-form-field>
  </mat-cell>
</ng-container>

  <ng-container matColumnDef="monto">
    <mat-header-cell *matHeaderCellDef>monto</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ element.monto }}
    </mat-cell>
</ng-container>

<ng-container matColumnDef="actions">
  <mat-header-cell *matHeaderCellDef></mat-header-cell>
  <mat-cell *matCellDef="let element; let i=index">
    <button mat-icon-button (click)="changeEdit(element, i)" *ngIf="element.edit"><mat-icon class="icon-color">
      edit</mat-icon></button>
    <button mat-icon-button (click)="saveEdit(element, i)" *ngIf="!element.edit"><mat-icon class="icon-color">
      save</mat-icon></button>
    <button mat-icon-button (click)="cancelEdit(element, i)" *ngIf="!element.edit"><mat-icon class="icon-color">
      cancel</mat-icon></button>
  </mat-cell>
</ng-container>

   </mat-table>
   <br>
    <div style="display: flex;align-items: center; justify-content: space-around;">

      <button mat-raised-button color="primary" (click)="close()">Guardar</button>
      <button mat-raised-button color="warn" (click)="close()">Cerrar</button>
    </div>
  <br>
</div>
